import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TagService {
  private colorUpdates = new BehaviorSubject<{addressId: string, color: string}>(null);
  public colorUpdates$ = this.colorUpdates.asObservable();

  updateColor(addressId: string, color: string) {
    this.colorUpdates.next({ addressId, color });
  }
} 